export const API_CONSTANTS = {
  GET_DENTISTS: "/receptionist/dentists",
  GET_ALL_DENTISTS: "/user/retrieve-all-dentists",
};